const buildInitials = (user: { firstName: string | null; lastName: string | null }): string => {
  return `${user.firstName?.charAt(0) || ''}${user.lastName?.charAt(0) || ''}`;
};

export default buildInitials;
